import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=507a3ce8&scoped=true&"
import script from "./Forbidden.vue?vue&type=script&lang=js&"
export * from "./Forbidden.vue?vue&type=script&lang=js&"
import style0 from "./Forbidden.vue?vue&type=style&index=0&id=507a3ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507a3ce8",
  null
  
)

export default component.exports